import React from 'react';
import { BlockRenderer } from '../renderer';

/**
 * RowBlock — invisible layout container whose COLUMN children render side
 * by side with equal widths. Created automatically when a block is dropped
 * on the left/right edge of another; unwrapped automatically when only one
 * column remains (see cleanupEmptyContainers).
 */
export const RowBlock = ({ block, ...passThrough }) => (
  <div className="row-block">
    {block.children?.map((column) => (
      <BlockRenderer key={column.id} block={column} {...passThrough} />
    ))}
  </div>
);
